// plugins/draw/DrawPlugin.ts

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../store/store";
import { useMapContext } from "../../core/MapContext";
import { createDrawingTool } from "./drawToolFactory";

export const DrawPluginComponent = () =>
{
  const { mode, features, editingFeatureId, featureToDelete } = useSelector((state: RootState) => state.draw);

  const dispatch = useDispatch();

  const { mapType, mapInstance } = useMapContext();

  useEffect(() =>
  {
    if (!mapInstance) return;

    let tool: ReturnType<typeof createDrawingTool> | null = null;

    const run = () =>
    {
      tool = createDrawingTool(mapInstance, mapType, mode, editingFeatureId, features, dispatch);
      tool.activate();
    };

    if ((mapInstance as any).isStyleLoaded?.())
    {
      run();
    } else
    {
      (mapInstance as any).once("load", run);
    }

    return () =>
    {
      (mapInstance as any).off?.("load", run);
      tool?.deactivate();
    };
  }, [mode, mapInstance, editingFeatureId, featureToDelete]);

  return null;
};
